// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeMostFalsyValues = (obj: any) => {
    // removes: null, undefined, ''
    const result = Object.entries(obj).reduce((arr, curr) => {
        const [key, value] = curr;
        const isNull = value === null;
        const isUndefined = value === undefined;
        const isEmptyString = value === '';

        if (isNull || isUndefined || isEmptyString) {
            return arr;
        }

        return {
            ...arr,
            [key]: value
        };
    }, {});

    return result;
};
